export function toDictionary(array, keySelector, valueSelector) {
    keySelector = keySelector || (i => i)
    valueSelector = valueSelector || (i => i)

    const result = {}

    if (!array) {
        return result
    }

    array.forEach(item => {
        result[keySelector(item)] = valueSelector(item)
    })

    return result
}

export function distinct(array) {
    return [...new Set(array)]
}

export function distinctBy(array, keySelector = null, valueSelector = null) {
    if (!array) {
        return []
    }

    keySelector = keySelector ?? (i => i)
    valueSelector = valueSelector ?? (i => i)

    const seen = new Set()
    const distinct = []

    array.forEach(a => {
        const key = keySelector(a)
        if (!seen.has(key)) {
            seen.add(key)
            distinct.push(valueSelector(a))
        }
    })

    return distinct
}

export function groupBy(array, keySelector, valueSelector) {
    keySelector = keySelector || (i => i)
    valueSelector = valueSelector || (i => i)

    const seen = new Set()
    const result = {}

    if (!array) {
        return result
    }

    array.forEach(item => {
        let key = keySelector(item)
        let value = valueSelector(item)

        if (seen.has(key)) {
            result[key].push(value)
        } else {
            result[key] = [value]
            seen.add(key)
        }
    })

    return result
}

export function sortText(array) {
    return array.slice(0).sort((lhs, rhs) => {
        if (lhs?.localeCompare) {
            return lhs.localeCompare(rhs)
        }

        if (rhs?.localeCompare) {
            return -rhs.localeCompare(lhs)
        }

        return 0
    })
}

export function sortBy(array, fn) {
    const mapped = array.map((a, i) => ({ i, k: fn(a, i) }))
    mapped.sort((lhs, rhs) => lhs.k - rhs.k)
    return mapped.map(k => array[k.i])
}
